import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CavOfflineSyncFilterState, SortField, SortOrder } from "./type";

const INITIAL_STATE: CavOfflineSyncFilterState = {
  filters: {
    storeIds: [],
    dateFrom: undefined,
    dateTo: undefined,
    status: [],
    sortBy: undefined,
    sortOrder: undefined,
    meta: {
      currentPage: 1,
      perPage: 25,
    },
  },
};

type FilterKeys = keyof CavOfflineSyncFilterState["filters"];

const cavOfflineSyncFilterSlice = createSlice({
  name: "cavOfflineSyncFilters",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter<K extends FilterKeys>(
      state: CavOfflineSyncFilterState,
      action: PayloadAction<{
        key: K;
        value: CavOfflineSyncFilterState["filters"][K];
      }>
    ) {
      state.filters[action.payload.key] = action.payload.value;
      if (action.payload.key !== "meta") {
        state.filters.meta.currentPage = 1;
      }
    },
    resetFilters(state) {
      state.filters = INITIAL_STATE.filters;
    },
    setPagination(
      state,
      action: PayloadAction<{ currentPage: number; perPage: number }>
    ) {
      state.filters.meta = action.payload;
    },
    setSort(
      state,
      action: PayloadAction<{ sortBy: SortField | undefined; sortOrder: SortOrder | undefined }>
    ) {
      state.filters.sortBy = action.payload.sortBy;
      state.filters.sortOrder = action.payload.sortOrder;
      state.filters.meta.currentPage = 1;
    },
  },
});

export const { setFilter, resetFilters, setPagination, setSort } =
  cavOfflineSyncFilterSlice.actions;
export default cavOfflineSyncFilterSlice.reducer;
